module.exports = __webpack_public_path__ + "media/images/japan/squared-dcf29aac5a149a70cb7ea753db1d97db.svg";